import TemporaryLanding from './TemporaryLanding';
import './temporary.css';

function App() {
  return <TemporaryLanding />;
}

export default App;
